import React, { useState, useEffect, useRef } from 'react';
import {
    AppLayout, ContentLayout, Tabs, Box, SpaceBetween, Container, Header, Grid, Spinner
} from '@amzn/awsui-components-react';
import { useSelector } from 'react-redux';
import { useHistory, useLocation } from 'react-router-dom';
import appSettings from './app_settings';
import SideNav from './SideNav';
import DeliverablesPage from './DeliverablesPage';
import { isCorpAdmin } from '../Templates/Utils/Permissions';
import craLogo from '../../images/cra_logo.png';

import SectionManagementComponent from './SectionManagementComponent';
import TieOutPage from './TieOutPage';
import { getQuarterForUpload } from './Utility';

import './styles.scss';

export default (props) => {
    const history = useHistory();
    const location = useLocation();
    const currentStage = useSelector((globalState) => globalState.auth.currentStage);
    const userId = useSelector((globalState) => globalState.auth.userId);
    const isCorpReportingAdmin = useSelector((globalState) => globalState.auth.isCorpReportingAdmin);
    const isPortalAdmin = useSelector((globalState) => globalState.auth.isPortalAdmin);
    const isSupportAdmin = useSelector((globalState) => globalState.auth.isSupportAdmin);

    const searchParams = new URLSearchParams(location.search);
    const tabFromQuery = searchParams.get('tab');
    const validTabIds = ['home', 'deliverables', 'tieout'];
    const initialTab = (tabFromQuery && validTabIds.includes(tabFromQuery)) ? tabFromQuery : 'home';

    const [NavOpen, setNavOpen] = useState(false);
    const [activeTabId, setActiveTabId] = useState(initialTab);

    const isAnyAdmin = isCorpReportingAdmin || isPortalAdmin || isSupportAdmin;

    const tabs = [
        {
            id: 'home',
            label: 'Section Management',
            content: <SectionManagementComponent quarter={getQuarterForUpload()} associationId={appSettings[currentStage]?.appId} associationType="APP_ID" isAdmin={isCorpReportingAdmin || isPortalAdmin} />
        },
        {
            id: 'deliverables',
            label: 'Deliverables',
            content: <DeliverablesPage {...props} embedded={true} />
        },
        {
            id: 'tieout',
            label: 'Tie-Out',
            content: <TieOutPage {...props} embedded={true} />
        },
    ];

    const Content = (
        currentStage ? (
            <ContentLayout defaultPadding>
                <SpaceBetween size="l">
                    <Tabs
                        activeTabId={activeTabId}
                        onChange={({ detail }) => {
                            setActiveTabId(detail.activeTabId);
                            const params = new URLSearchParams(location.search);
                            params.set('tab', detail.activeTabId);
                            history.replace({ search: params.toString() });
                        }}
                        tabs={tabs}
                    />
                </SpaceBetween>
            </ContentLayout>
        ) : (
            <Box><Spinner /> Loading...</Box>
        )
    );

    return (
        <AppLayout
            disableContentPaddings={true}
            content={Content}
            contentType="default"
            navigationOpen={NavOpen}
            navigation={<SideNav activeHref="/CorpReportingHome" id={appSettings[currentStage]?.appId} isAdmin={isCorpReportingAdmin} />}
            onNavigationChange={() => setNavOpen(!NavOpen)}
            toolsHide={true}
        />
    );
};
